export default "__VITE_ASSET__CdxLcsNd__"